import type { GarageState } from "@hachi/core";
import type { SyncState } from "./sync";

/** Where the garage lives on this device. Tests pass an in-memory one. */
export interface LocalDb {
  load(): Promise<{ state: GarageState; sync: SyncState } | null>;
  saveState(st: GarageState): Promise<void>;
  saveSync(s: SyncState): Promise<void>;
  clear(): Promise<void>;
}

/** IndexedDB via Dexie, downloaded separately so the first screen doesn't wait for it. */
export function indexedDb(): LocalDb {
  const real = import("./localdb-dexie").then((m) => m.createIndexedDb());
  return {
    load: () => real.then((d) => d.load()),
    saveState: (st) => real.then((d) => d.saveState(st)),
    saveSync: (x) => real.then((d) => d.saveSync(x)),
    clear: () => real.then((d) => d.clear()),
  };
}

/** A database that always fails, for browsers with IndexedDB blocked: the old-format copy carries on alone. */
export const noLocalDb: LocalDb = {
  load: () => Promise.resolve(null),
  saveState: () => Promise.resolve(),
  saveSync: () => Promise.resolve(),
  clear: () => Promise.resolve(),
};
